import Utils from "../../services/Utils.js";

export function getAccountBalanceTemplate(account_balance, role) {
    return `<div class="accountBalanceRow ${
      role != "User" && account_balance.type.toLowerCase() == "sport" ? '' : 'fiveColumnsHolder'}">
    ${
      role != "User"
        ? `<span>${account_balance.username}</span>`
        : "<span>*</span>"
    }
    <span> ${
    Utils.formatNumber( account_balance.stake ? account_balance.stake : 0)
  }</span>
    
    <span>${Utils.formatNumber( account_balance.win ? account_balance.win : 0)}</span>
    <span>${account_balance.type.toLowerCase() == "casino" ?  Utils.formatNumber( account_balance.jackpot ? account_balance.jackpot : 0) : "-"}</span>
    
    ${
      role != "User" && account_balance.type.toLowerCase() == "sport"
        ? `<span>${Utils.formatNumber(
            account_balance.percentage
              ? account_balance.percentage
              : 0
          )}</span>`
        : ""
    }
    
    ${
        role != "User"
            ? `<span>${Utils.formatNumber(
            account_balance.difference
                ? account_balance.difference
                : 0
            )}</span>`
            : ""
    }
    ${
      role == "User"
          ? `<span>${Utils.formatNumber(
          account_balance.difference
              ? account_balance.difference
              : 0
          )}</span>`
          : ""
  }
</div>`;
}

export function getSmFinanceTemplate(account_balance) {
  return `<div class="accountBalanceRow">
   <span style="width:16%;">${account_balance.username}</span>
      
  <span style="width:14%;">${
    Utils.formatNumber( account_balance.dif_sport ? account_balance.dif_sport : 0)
  }</span>
  <span style="width:14%;">${
    Utils.formatNumber( account_balance.dif_sport_mng ? account_balance.dif_sport_mng : 0)
  }</span>
  <span style="width:14%;">${
    Utils.formatNumber( account_balance.dif_casino ? account_balance.dif_casino : 0)
  }</span>
  <span style="width:14%;">${
    Utils.formatNumber( account_balance.dif_livecasino ? account_balance.dif_livecasino : 0)
  }</span>
  <span style="width:14%;">${
    Utils.formatNumber( account_balance.dif_virtual ? account_balance.dif_virtual : 0)
  }</span>
  <span style="width:14%;">${
    Utils.formatNumber( account_balance.difference ? account_balance.difference : 0)
  }</span>
</div>`;
}